import { __awaiter } from "tslib";
import { PermissionStatus, } from '@office-start/metaos-hub-sdk';
import { useEffect, useState } from 'react';
import { getHubSdkDevicePermission } from '../utilities/getHubSdkDevicePermission';
export const useCurrentAppInitialPermissions = ({ appDefinitionPermissions, devicePermissionsStorage, appHostPermissionsEnabled, }) => {
    const [devicePermissionsCapabilityItems, setDevicePermissionsCapabilityItems,] = useState([]);
    useEffect(() => {
        if (appHostPermissionsEnabled) {
            function fetchDevicePermissionsCapabilityItems() {
                return __awaiter(this, void 0, void 0, function* () {
                    const supportedPermissions = appDefinitionPermissions
                        .map((permission) => {
                        const localDevicePermission = getHubSdkDevicePermission({
                            permissionToTranslate: permission,
                        });
                        return localDevicePermission;
                    })
                        .filter((permission) => permission !== undefined)
                        .map((p) => p);
                    const getAllPermission = yield devicePermissionsStorage.getPermissions();
                    const devicePermissionsCapabilityItems = supportedPermissions.map((supportedPermission) => {
                        var _a;
                        const foundPermission = getAllPermission.find((element) => element.permission === supportedPermission);
                        const capabilityItem = {
                            devicePermission: supportedPermission,
                            isConsentGivenOnCurrentDevice: (_a = (foundPermission === null || foundPermission === void 0 ? void 0 : foundPermission.status) ===
                                PermissionStatus.Consented) !== null && _a !== void 0 ? _a : false,
                        };
                        return capabilityItem;
                    });
                    setDevicePermissionsCapabilityItems(devicePermissionsCapabilityItems);
                });
            }
            fetchDevicePermissionsCapabilityItems();
        }
    }, [
        appDefinitionPermissions,
        devicePermissionsStorage,
        appHostPermissionsEnabled,
    ]);
    return [
        devicePermissionsCapabilityItems,
        setDevicePermissionsCapabilityItems,
    ];
};
//# sourceMappingURL=useCurrentAppInitialPermissions.js.map